import type { Chart, RequestedConfig } from './types';

export const getDataRequestedConfig = (
  config: Chart,
): RequestedConfig<Chart> => {
  const { excludedSplitOptions, syncedYAxes, ...otherProps } = config;

  return otherProps;
};
